import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.943 13.016a9 9 0 1 0 -8.915 7.984","key":"svg-0"}],["path",{"d":"M16 22l5 -5","key":"svg-1"}],["path",{"d":"M21 21.5v-4.5h-4.5","key":"svg-2"}],["path",{"d":"M12 7v5l2 2","key":"svg-3"}]]

const IconClockShare = createReactComponent('outline', 'clock-share', 'ClockShare', __iconNode);

export default IconClockShare;